module.exports = __webpack_public_path__ + "img/sub16.f50117d5.jpg";